/* eslint-disable */
import axios from 'axios';
const FormData = require('form-data');

const mockError = "Beispielfehler!"

const protocol = "https://"
const host = "nifty-almeida.82-165-176-243.plesk.page/"

const storage = window.sessionStorage;
let userSessionToken = storage.getItem('userSessionToken');

function getAllDeals(id, callback) {
    const route = "get_deal_details2.php"
    const url = protocol+host+route+'?'+id

    axios.get(url, {
        headers: {
            'Authorization': 'Bearer ' + userSessionToken
        },
        params: {
          id: id
        }
    }).then((response) => {
        // handle success
        callback(response.data, null)
    })
    .catch((error) => {
        // handle error
        console.log(error)
        callback(null, error)
    })
}

function loginUser(dealId, password, callback) {
    const route = 'session.php'

    console.log('UserID: ' + dealId)

    const credentials = dealId + ':' + password;
    const headerValue = window.btoa(unescape(encodeURIComponent(credentials)));
    const completeHeader = 'Basic ' + headerValue;

    axios.get(protocol+host+route, {
            headers: {
                    'Authorization': completeHeader,
                    'Access-Control-Allow-Headers': "*",
            }
    }).then((response) => {
            callback(response.data, null);
            const sessionToken = response.data.substring(1);
            storage.setItem('userSessionToken', sessionToken);
            userSessionToken = storage.getItem('userSessionToken');
    }).catch((error) => {
            callback(null, error)
            console.log(error);
    })
}

export {
        getAllDeals, loginUser
}
